import React, { useContext } from "react";

import View from "./view";

export default ({ isNavMin, setIsNavMin }) => {
  return <View isNavMin={isNavMin} setIsNavMin={setIsNavMin} />;
};
